function Footer() {
  return (
    <header className="page-header page-header-border">
      <div className="container-lg px-3 d-flex flex-row justify-content-between align-items-center">
        <div className="padd-mobile d-lg-flex justify-content-between w-full">
          <p>Prostorno Planiranje - Ministarstvo prostornog planiranja, urbanizma i državne imovine © 2025.</p>
          <a
            href="https://restartit.me/"
            target="_blank"
            rel="noopener noreferrer"
            className="date-of-dodatno restart-link"
          >
            Restart IT Software Solutions
          </a>
        </div>{" "}
      </div>
    </header>
  );
}

export default Footer;
